<script>
import { MapGender, MapRoles, MapAgentAuth } from "@/common/util";
import xorBy from "lodash/xorBy";
import cloneDeep from "lodash/cloneDeep";

export default {
  data() {
    return {
      formInline: {
        name: ""
      },
      userData: {
        staffId: "--",
        name: "--",
        phone: "--",
        auth: []
      },
      currentPage: 1,
      tableData: [],
      buttonArray: [
        {
          text: "编辑",
          key: "edit"
        }
      ],
      tableButtonArray: [
        {
          text: "解除关联",
          key: "remove"
        }
      ],
      formInputArray: [
        // {
        //   label: "工号",
        //   keyName: "staffId",
        //   type: "text",
        //   isDisable: true
        // },
        {
          label: "姓名",
          keyName: "name",
          type: "text",
          isDisable: true
        },
        {
          label: "关联机构",
          keyName: "stationName",
          type: "select",
          children: []
        }
      ],
      editUserArray: [
        // {
        //   label: "工号",
        //   keyName: "staffId",
        //   type: "text"
        // },
        {
          label: "姓名",
          keyName: "name",
          type: "text"
        },
        {
          label: "性别",
          keyName: "gender",
          type: "radio",
          children: [
            {
              label: "男",
              keyName: "MALE"
            },
            {
              label: "女",
              keyName: "FEMALE"
            }
          ]
        },
        {
          label: "联系电话",
          keyName: "phone",
          type: "text"
        },
        {
          label: "权限",
          keyName: "auths",
          type: "checkbox",
          children: [
            {
              label: "开单",
              keyName: "ROLE_SALESMAN",
              select: true
            },
            {
              label: "数据统计",
              keyName: "ROLE_DATA_MONITOR",
              select: true
            }
          ]
        },
        {
          label: "角色",
          keyName: "role",
          type: "select",
          children: [
            {
              label: "医生",
              keyName: "ROLE_DOCTOR"
            },
            {
              label: "视觉训练师",
              keyName: "ROLE_AGENT_OPTOMETRIST"
            },
            {
              label: "代理商财务",
              keyName: "ROLE_AGENT_FINANCIAL"
            },
            {
              label: "主管",
              keyName: "ROLE_STATION_MANAGER"
            }
          ]
        }
      ],
      editUser: false,
      addingStation: false,
      removeStation: false,
      searchData: "",
      checkBoxSelect: true,
      AgenteAuthorizedList: [],
      canAgenteAuthorized: true
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      const userId = this.$route.params.accountId;
      const userData = await this.$http.getAgentAccountById(userId);
      const stationName =
        this.formInline.name.length > 0 ? this.formInline : null;
      const userStationList = await this.$http.getAgentAccountById(
        userId,
        true,
        stationName
      );
      console.log("user", userData);
      if (userData) {
        this.userData.staffId = userData.staffId;
        this.userData.name = userData.name;
        this.userData.phone = userData.phone;
        this.userData.auths = userData.auths;
        this.userData.gender = MapGender(userData.gender);
        this.userData.role = MapRoles(userData.roles[0]);
        this.userData.auth = userData.auths.map(o => MapAgentAuth(o));
      }
      if (userStationList && userStationList.content) {
        this.tableData = userStationList.content;
      }

      const AgenteAuthorizedList = await this.$http.getAgenteAuthorizedList();
      this.AgenteAuthorizedList = AgenteAuthorizedList;
      if (AgenteAuthorizedList) {
        let tempChildren = [];
        const xorList = xorBy(
          AgenteAuthorizedList,
          this.tableData,
          "stationUUID"
        );
        if (xorList.length > 0) {
          xorList.forEach(o =>
            tempChildren.push({
              label: o.name,
              keyName: o.stationUUID
            })
          );
          let tempFormInputArray = this.formInputArray.filter(
            o => o.keyName !== "stationName"
          );
          tempFormInputArray.push({
            label: "关联机构",
            keyName: "stationName",
            type: "select",
            children: tempChildren
          });
          this.formInputArray = tempFormInputArray;
        } else {
          this.canAgenteAuthorized = false;
        }
      }
    },
    async removeByID() {
      const row = this.defaultValue;
      const userId = this.$route.params.accountId;
      const postData = {
        userId,
        stationUUID: row.stationUUID
      };
      let result = await this.$http.updateAgenteAuthorized("remove", postData);
      if (result === "success") {
        this.loadData();
      }
    },
    async onAddingNew(data) {
      if (data) {
        const userId = this.$route.params.accountId;
        const postData = {
          userId,
          stationUUID: data.stationName
        };
        let result = await this.$http.updateAgenteAuthorized("add", postData);
        this.addingStation = false;
        if (result === "success") {
          this.loadData();
        }
      }
    },
    onOperationClick(row) {
      this.defaultValue = row;
      this.removeStation = true;
    },
    async onSubmit() {
      const userId = this.$route.params.accountId;
      const stationName =
        this.formInline.name.length > 0 ? this.formInline : null;
      const userStationList = await this.$http.getAgentAccountById(
        userId,
        true,
        stationName
      );
      if (userStationList && userStationList.content) {
        this.tableData = userStationList.content;
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    // onClick() {
    //   console.log("submit!", this.formInline);
    // },
    // onOperationClick(row, index) {
    //   console.log("add new!", row, index);
    // },
    async onEditAccount(form) {
      const userId = this.$route.params.accountId;
      const updateData = cloneDeep(form);
      updateData.userId = userId;
      updateData.oldRole = MapRoles(this.userData.role);
      let result = await this.$http.updateAgentAccountInfo(
        "editAccount",
        updateData
      );
      this.loadData();
    },
    willAddingStation() {
      if (this.canAgenteAuthorized) {
        this.addingStation = true;
      } else {
        this.$message.warning("暂时没有可以关联的机构了！");
      }
    }
  }
};
</script>
<template>
  <div class="agencyAccountDetailIndex">
    <el-card class="box-card basicInfo" shadow="never">
      <div slot="header" class="clearfix">
        <span class="cardTitleText">基本信息</span>
        <DialogForm
          v-if="editUser"
          formTitle="编辑"
          :formInputArray="editUserArray"
          @close="editUser = false"
          @submitForm="onEditAccount"
          :defaultValue="userData"
        />
        <textButtonGroup
          class="editButton"
          :buttonArray="buttonArray"
          @onOperationClick="editUser = true"
        />
      </div>
      <div class="text item">
        <el-row :gutter="24">
          <!-- <el-col :span="6">
            <div class="grid-content bg-purple">工号: {{userData.staffId}}</div>
          </el-col> -->
          <el-col :span="6">
            <div class="grid-content bg-purple">姓名: {{userData.name}}</div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">手机号: {{userData.phone}}</div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              权限:
              <el-checkbox
                v-for="item in userData.auth"
                :key="userData.name + item"
                v-model="checkBoxSelect"
                class="checkBoxLabel"
                disabled
              >{{item}}</el-checkbox>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-card
      v-if="this.userData.role && this.userData.role !== '代理商财务'"
      class="box-card withoutBorderBottom"
      shadow="never"
    >
      <div slot="header" class="clearfix cardHeader">
        <DialogForm
          v-if="addingStation"
          formTitle="关联机构"
          :formInputArray="formInputArray"
          @close="addingStation = false"
          @submitForm="onAddingNew"
          :defaultValue="userData"
        />
        <DialogForm
          v-if="removeStation"
          formTitle="确认解除关联？"
          :defaultValue="userData"
          @close="removeStation = false"
          @submitForm="removeByID"
          confirmButton="确认"
        />
        <elementButton size="mini" class="buttonStyle" @click="willAddingStation">关联机构</elementButton>
        <el-form
          :inline="true"
          :model="formInline"
          size="mini"
          class="demo-form-inline searchLocation"
        >
          <el-form-item label="机构名称">
            <el-input
              calss="searchInput"
              @keyup.enter.native="onSubmit"
              v-model="formInline.name"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <elementButton size="mini" class="buttonStyle" @click="onSubmit">搜索</elementButton>
          </el-form-item>
        </el-form>
      </div>
      <div class="text item">
        <el-table
          :data="tableData"
          class="AgencyRangeTable"
          :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
          :cell-style="{'padding-left': '5px'}"
        >
          <el-table-column prop="stationId" align="left" label="机构Id" width="150"></el-table-column>
          <el-table-column prop="name" align="left" label="机构名称" width="150"></el-table-column>
          <el-table-column prop="location" align="left" label="地址"></el-table-column>
          <el-table-column prop="operation" align="left" label="操作" width="150">
            <template slot-scope="scope">
              <textButtonGroup
                :buttonArray="tableButtonArray"
                :rowData="scope.row"
                @onOperationClick="onOperationClick"
              />
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination
          @size-change="handleSizeChange"
          background
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="100"
          layout="prev, pager, next, jumper"
          :total="1000"
        ></el-pagination>-->
      </div>
    </el-card>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.agencyAccountDetailIndex {
  background-color: #f5f6f7;
  .basicInfo {
    margin: 15px 0;
  }
  .cardTitleText {
    font-size: 16px;
    font-weight: bold;
  }
  .cardHeader {
    margin-bottom: -20px;
  }

  .buttonStyle {
    background-color: #00c1de;
    border-color: #00c1de !important;
    width: 83px;
    height: 36px;
  }

  .searchLocation {
    float: right;
    .el-form-item--mini .el-form-item__content,
    .el-form-item--mini .el-form-item__label {
      line-height: 36px;
    }
    .el-input--mini .el-input__inner {
      height: 36px;
    }
    .el-input.is-active .el-input__inner,
    .el-input__inner:focus {
      border-color: #00c1de;
    }
  }
  .AgencyRangeTable {
    // width: 96%;
    margin: auto;
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
  }

  .grid-content {
    padding: 15px 0px;
    border-radius: 4px;
  }
  .el-pagination {
    text-align: center;
    margin-top: 10px;
  }

  .text {
    font-size: 14px;
    padding-top: 0px;
  }

  .item {
    margin-bottom: 18px;
    .checkBoxLabel {
      color: #303133;
      .el-checkbox__input.is-disabled + span.el-checkbox__label {
        color: #303133;
      }
    }
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both;
  }

  .editButton {
    float: right;
  }
  .withoutBorderBottom {
    border-bottom: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/agencyAccounts/agencyDetail.vue